"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateContext = exports.StateProvider = void 0;
var _react = require("react");
const stateContext = exports.stateContext = /*#__PURE__*/(0, _react.createContext)({});
const StateProvider = exports.StateProvider = stateContext.Provider;
